import {charcoal} from '../../sass/v2/_exports.sass';

export const XIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5893 8.45898L15.932 14.115L10.276 8.45898L8.39062 10.3443L14.0466 16.0003L8.39062 21.6563L10.276 23.5417L15.932 17.8857L21.5893 23.5417L23.4746 21.6563L17.8186 16.0003L23.4746 10.3443L21.5893 8.45898Z"
        fill={color}
      />
    </svg>
  );
};
